import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Map.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
import {
  gsap,
  Power2,
  MotionPathPlugin
} from 'gsap/all';
gsap.registerPlugin(Power2);
gsap.registerPlugin(MotionPathPlugin);
const Map = () => {

  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { stage, updateTransition } = state;
  const [init, setInit] = useState(false);
  const [timeline, setTimeline] = useState(null);
  const [localStage, setLocalStage] = useState(0);
  const [transition, setTransition] = useState(false);
  const refWrap = useRef(null);
  const refOverlay = useRef(null);
  const refContainer = useRef(null);
  const refBody = useRef(null);
  const refBg = useRef(null);
  const refBgOverlay = useRef(null);
  const refChart1 = useRef(null);
  const refChart1Text = useRef(null);
  const refChart1Circle = useRef(null);
  const refChart1CircleBack = useRef(null);
  const refChart2Circle = useRef(null);
  const refChart2 = useRef(null);
  const refChart2Img1 = useRef(null);
  const refChart2Img2 = useRef(null);
  const refChart2Img3 = useRef(null);
  const refChart2Text1 = useRef(null);
  const refChart2Text2 = useRef(null);
  const refChart2Text3 = useRef(null);
  const refSvg1 = useRef(null);
  const refSvg2 = useRef(null);
  const refSvg1Inner1 = useRef(null);
  const refSvg1Inner2 = useRef(null);
  const refSvg1Inner3 = useRef(null);
  const refSvg1Inner4 = useRef(null);
  const refSvg1Inner1Mask = useRef(null);
  const refSvg1Inner3Mask = useRef(null);
  const refSvg2Inner1 = useRef(null);
  const refSvg2Inner2 = useRef(null);
  const refSvg2Inner1Mask = useRef(null);
  const refSvg2Inner2Mask = useRef(null);
  const refPoint1 = useRef(null);
  const refCityPoints = useRef([]);
  const refLabels = useRef([]);
  const refCountries = useRef([]);
  useEffect(() => {
    const tl = gsap.timeline({ paused: true });
    const wrap = refWrap.current;
    const chart1 = refChart1.current;
    const chart1Circle = refChart1Circle.current;
    const chart1CircleBack = refChart1CircleBack.current;
    const chart1Text = refChart1Text.current;
    const chart2 = refChart2.current;
    const chart2Circle = refChart2Circle.current;
    const chart2Img1 = refChart2Img1.current;
    const chart2Img2 = refChart2Img2.current;
    const chart2Img3 = refChart2Img3.current;
    const chart2Text1 = refChart2Text1.current;
    const chart2Text2 = refChart2Text2.current;
    const chart2Text3 = refChart2Text3.current;
    const point1 = refPoint1.current;
    const point1Circle = point1.querySelectorAll('circle')[2];
    const point2 = refCityPoints.current[0];
    const point3 = refCityPoints.current[1];
    const point4 = refCityPoints.current[2];
    const point5 = refCityPoints.current[3];
    const point6 = refCityPoints.current[4];
    const point7 = refCityPoints.current[5];
    const body = refBody.current;
    const overlay = refOverlay.current;
    const container = refContainer.current;
    const bg = refBg.current;
    const bgOverlay = refBgOverlay.current;
    const svg1Path1 = refSvg1Inner1.current;
    const svg1Path2 = refSvg1Inner2.current;
    const svg1Path3 = refSvg1Inner3.current;
    const svg1Path4 = refSvg1Inner4.current;
    const svg1Path1Mask = refSvg1Inner1Mask.current;
    const svg1Path3Mask = refSvg1Inner3Mask.current;
    const svg2Path1 = refSvg2Inner1.current;
    const svg2Path2 = refSvg2Inner2.current;
    const svg2Path1Mask = refSvg2Inner1Mask.current;
    const svg2Path2Mask = refSvg2Inner2Mask.current;
    const label0 = refLabels.current[0];
    const label1 = refLabels.current[1];
    const label2 = refLabels.current[2];
    const label3 = refLabels.current[3];
    const label4 = refLabels.current[4];
    const label5 = refLabels.current[5];
    const label6 = refLabels.current[6];
    const country0 = refCountries.current[0];
    const country1 = refCountries.current[1];
    const country2 = refCountries.current[2];
    const country3 = refCountries.current[3];
    const country4 = refCountries.current[4];
    const country5 = refCountries.current[5];
    // const label7 = refLabels.current[7];
    tl
      .to(wrap, { duration: 0.1, ease: 'power2.inOut', opacity: 0 })
      .to(point1, {
        duration: 0.1, ease: 'power2.inOut', autoAlpha: 1, scale: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0,
          end: 0
        }
      }, '-=0.1')
      .to(overlay, { duration: 0.1, ease: 'power2.inOut', scale: 0 }, '-=0.1')
      .to(container, { duration: 0.1, ease: 'power2.inOut', scale: 1, x: '-50%', y: '-50%' }, '-=0.1')
      .to(point1Circle, { duration: 0.1, ease: 'power2.inOut', fill: '#67D672' }, '-=0.1')
      .to(chart1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart1Text, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2Img1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2Img2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2Img3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2Text1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2Text2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2Text3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(chart2Circle, { duration: 0.1, ease: 'power2.inOut', r: '25%', strokeWidth: '425' }, '-=0.1')
      .to(chart1Circle, { duration: 0.1, ease: 'power2.inOut', r: '25%', strokeWidth: '425', strokeDasharray: chart1Circle.getTotalLength(), strokeDashoffset: chart1Circle.getTotalLength(), autoAlpha: 1 }, '-=0.1')
      .to(chart1CircleBack, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, transformOrigin: '50% 50%' }, '-=0.1')
      .to(point2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, r: '16', fill: '#67D672' }, '-=0.1')
      .to(point3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(point4, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(point5, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, fill: '#67D672' }, '-=0.1')
      .to(point6, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, fill: '#67D672' }, '-=0.1')
      .to(point7, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, fill: '#67D672' }, '-=0.1')
      .to(label0, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, scale: '3', x: '-50%', y: '-50%' }, '-=0.1')
      .to(label1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, scale: '3', x: '-50%', y: '-50%' }, '-=0.1')
      .to(label2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, x: '-50%', y: '-50%' }, '-=0.1')
      .to(label3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label4, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label5, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label6, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(country0, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, left: '75.7%', top: '59.3%' }, '-=0.1')
      .to(country1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, left: '53.9%', top: '47.3%' }, '-=0.1')
      .to(country2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, left: '42%', top: '37%' }, '-=0.1')
      .to(country3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, left: '30.1%', top: '41.4%' }, '-=0.1')
      .to(country4, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, left: '17.1%', top: '45%' }, '-=0.1')
      .to(country5, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0, left: '23.8%', top: '42.5%' }, '-=0.1')
      // .to(label7, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      // .to(bg, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(bgOverlay, { duration: 0.1, autoAlpha: 1 }, '-=0.1')
      .to(svg1Path1, { duration: 0.1, strokeWidth: 8, strokeDasharray: svg1Path1.getTotalLength(), strokeDashoffset: svg1Path1.getTotalLength() * 3 }, '-=0.1')
      .to(svg1Path2, { duration: 0.1, strokeWidth: 2, strokeDasharray: svg1Path2.getTotalLength(), strokeDashoffset: svg1Path2.getTotalLength() * 3 }, '-=0.1')
      .to(svg1Path3, { duration: 0.1, strokeWidth: 4, autoAlpha: 0, strokeDasharray: svg1Path3.getTotalLength(), strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.305 }, '-=0.1')
      .to(svg1Path4, { duration: 0.1, autoAlpha: 0, strokeDasharray: svg1Path4.getTotalLength(), strokeDashoffset: svg1Path4.getTotalLength() * 3 + svg1Path4.getTotalLength() * (1 - 0.859) }, '-=0.1')
      .to(svg2Path1, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(svg2Path2, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(svg2Path1Mask, { duration: 0.1, strokeDasharray: svg2Path1Mask.getTotalLength(), strokeDashoffset: svg2Path1Mask.getTotalLength() }, '-=0.1')
      .to(svg2Path2Mask, { duration: 0.1, strokeDasharray: svg2Path2Mask.getTotalLength(), strokeDashoffset: svg2Path2Mask.getTotalLength() * 3 }, '-=0.1')
      .to(svg1Path1Mask, { duration: 0.1, strokeDasharray: svg1Path1Mask.getTotalLength(), strokeDashoffset: svg1Path1Mask.getTotalLength() * 2 }, '-=0.1')
      .to(svg1Path3Mask, { duration: 0.1, strokeDasharray: svg1Path3Mask.getTotalLength(), strokeDashoffset: svg1Path3Mask.getTotalLength() * 2 - svg1Path3Mask.getTotalLength() * 0.275 }, '-=0.1')
      .to(body, { duration: 0.1, ease: 'power2.inOut', scale: '0.5', x: '-50.9%', y: '-11.4%' }, '-=0.1')
      .add('stage-0')
      .add('stage-1')
      .add('stage-2')

      .to(wrap, { duration: 0.5, opacity: 1 })
      .add('stage-3')

      .to(body, { duration: 2, scale: '0.32', x: '-34.1%', y: '0%' })
      .to(svg1Path1, { duration: 2, strokeDashoffset: svg1Path1.getTotalLength() * 2 }, '-=1')
      .to(label0, { duration: 0.5, autoAlpha: 1 }, '-=2.5')
      .to(point2, { duration: 1, autoAlpha: 1 })
      .to(label1, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      // .to(bg, { duration: 1, autoAlpha: 1 }, '-=2')
      .to(bgOverlay, { duration: 1, autoAlpha: 0 }, '-=2')
      .add('stage-4')

      .to(body, { duration: 2, ease: 'power2.inOut', scale: '1', x: '-51%', y: '-2.9%' })
      .to(svg1Path1, { duration: 2, ease: 'power2.inOut', strokeWidth: 4 }, '-=2')
      .to(label0, { duration: 0.5, scale: 1 })
      .to(label1, { duration: 0.5, scale: 1 }, '-=0.5')
      .to(label2, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label3, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(point4, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(point5, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(point7, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(country0, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(country1, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(country2, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(country3, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(country4, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(country5, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(svg2Path1, { duration: 0.1, autoAlpha: 1 }, '-=0.1')
      .to(svg2Path2, { duration: 0.1, autoAlpha: 1 }, '-=0.1')
      .to(svg2Path1Mask, { duration: 1, strokeDashoffset: svg2Path1Mask.getTotalLength() * 2 })
      .to(point1, {
        duration: 1, scale: 0.5,

        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0,
          end: 0.275
        }
      })
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.275 }, '-=1')
      .to(svg1Path2, { duration: 1, strokeDashoffset: svg1Path2.getTotalLength() * 3 - svg1Path2.getTotalLength() * 0.275 }, '-=1')
      .to(point3, { duration: 0.1, autoAlpha: 1 }, '-=1')
      .to(svg2Path2Mask, { duration: 1, strokeDashoffset: svg2Path2Mask.getTotalLength() * 3 + svg2Path2Mask.getTotalLength() * 0.785 }, '-=1')
      .to(svg2Path1Mask, { duration: 1, strokeDashoffset: svg2Path1Mask.getTotalLength() * 2 + svg2Path1Mask.getTotalLength() * 0.785 }, '-=1')
      .add('stage-5')

      .to(svg2Path1, { duration: 0.5, autoAlpha: 0 })
      .to(svg2Path2, { duration: 0.5, autoAlpha: 0 }, '-=0.5')
      .to(label3, { duration: 0.5, autoAlpha: 0 }, '-=0.5')
      .to(label2, { duration: 0.5, autoAlpha: 0 }, '-=0.5')
      .to(point4, { duration: 0.5, autoAlpha: 0 }, '-=0.5')
      .to(svg1Path1, { duration: 1, ease: 'power2.inOut', strokeWidth: 4 }, '-=1')
      .to(point1, { duration: 1, ease: 'power2.inOut', scale: 0.5 }, '-=1')
      .add('stage-6')

      .add('stage-7')
      .add('stage-8')

      .to(label2, { duration: 0.5, autoAlpha: 1 })
      .add('stage-9')
      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 1 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1.5, x: '-50%', y: '-50%' }, '-=1')

      .to(label2, { duration: 0.5, autoAlpha: 0 }, '-=0.5')
      .add('stage-10')
      .add('stage-11')

      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 0 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1, x: '-50%', y: '-50%' }, '-=1')

      .to(label2, { duration: 0.5, autoAlpha: 0 })
      .to(svg1Path3, { duration: 0.1, autoAlpha: 1, }, '-=0.1')
      .to(point5, { duration: 0.1, scale: 1, fill: '#006525' }, '-=0.1')
      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.35 }, '-=0.1')
      .to(point1, {
        duration: 1.5,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.275,
          end: 0.35
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1.5, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.35 }, '-=1.5')
      .to(svg1Path2, { duration: 1.5, strokeDashoffset: svg1Path2.getTotalLength() * 3 - svg1Path2.getTotalLength() * 0.35 }, '-=1.5')
      .to(body, { duration: 1.5, ease: 'none', x: '-45.2%', y: '-0.8%' }, '-=1.5')

      .add('stage-12')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.4 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.35,
          end: 0.4
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.4 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-44.4%', y: '4.2%' }, '-=1')
      .add('stage-13')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.45 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.4,
          end: 0.45
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.45 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-40.6%', y: '6.2%' }, '-=1')
      .add('stage-14')

      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 1 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1.5, x: '-50%', y: '-50%' }, '-=1')
      .to(country1, { duration: 0.1, left: '61.9%', top: '49%' }, '-=0.1')
      .add('stage-15')
      .add('stage-16')
      .add('stage-17')
      .add('stage-18')

      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 0 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1, x: '-50%', y: '-50%' }, '-=1')
      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.506 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.45,
          end: 0.506
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.506 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-36.4%', y: '7.6%' }, '-=1')

      // .to(label4, { duration: 1, autoAlpha: 1 })
      .add('stage-19')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.568 })
      .to(point7, { duration: 0.1, fill: '#006525' }, '-=1')
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.506,
          end: 0.568
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.568 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-32.7%', y: '6.2%' }, '-=1')

      // .to(label4, { duration: 1, autoAlpha: 0 }, '-=1')
      .add('stage-20')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.611 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.568,
          end: 0.611
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.611 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-29.6%', y: '8.2%' }, '-=1')
      .to(svg1Path4, { duration: 0.1, autoAlpha: 1 }, '-=0.1')
      .to(svg1Path1Mask, { duration: 0.1, strokeDashoffset: svg1Path1Mask.getTotalLength() * 3 - svg1Path1Mask.getTotalLength() * 0.859 }, '-=0.1')
      .to(svg1Path2, { duration: 0.1, strokeDashoffset: svg1Path2.getTotalLength() * 3 - svg1Path2.getTotalLength() * 0.859 }, '-=0.1')
      .to(point6, { duration: 0.1, autoAlpha: 1 }, '-=0.1')
      .add('stage-21')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.646 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.611,
          end: 0.646
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.646 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-27.2%', y: '9.1%' }, '-=1')
      .to(country3, { duration: 1, autoAlpha: 0 }, '-=1')
      .to(point2, { duration: 0.1, r: '4' }, '-=0.1')
      .add('stage-22')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.682 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.646,
          end: 0.682
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.682 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-24.3%', y: '9.8%' }, '-=1')
      .to(country3, { duration: 1, autoAlpha: 1 }, '-=1')
      .to(label1, { duration: 0.1, autoAlpha: 0, x: '87%', y: '-190%' }, '-=0')
      .add('stage-23')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.72 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.682,
          end: 0.72
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.72 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-21.6%', y: '10.6%' }, '-=1')
      .to(label5, { duration: 1, autoAlpha: 0 }, '-=1')
      .add('stage-24')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.754 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.72,
          end: 0.754
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.754 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-19.3%', y: '11.8%' }, '-=1')
      .add('stage-25')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.794 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.754,
          end: 0.794
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.794 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-16.4%', y: '10.4%' }, '-=1')
      .to(label5, { duration: 1, autoAlpha: 1 })
      .add('stage-26')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.815 })
      .to(label5, { duration: 1, autoAlpha: 0 }, '-=1')
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.794,
          end: 0.815
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.815 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-14.8%', y: '9.6%' }, '-=1')
      .to(label1, { duration: 0.1, x: '-42.8%', y: '-297.5%' }, '-=0.1')
      .add('stage-27')

      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.859 })
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.815,
          end: 0.859
        }
      }, '-=1')
      .to(svg1Path1, { duration: 1, strokeDashoffset: svg1Path1.getTotalLength() * 2 - svg1Path1.getTotalLength() * 0.859 }, '-=1')
      .to(body, { duration: 1, ease: 'none', x: '-11.9%', y: '6.5%' }, '-=1')
      .to(label1, { duration: 1, autoAlpha: 1 }, '-=1')
      .to(label6, { duration: 1, autoAlpha: 1 }, '-=1')
      .add('stage-28')
      .to(point6, { duration: 0.1, fill: '#006525' })
      .to(svg1Path3, { duration: 1, strokeDashoffset: svg1Path3.getTotalLength() * 3 - svg1Path3.getTotalLength() * 0.859 }, '-=0.1')
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.859,
          end: 1.0
        }
      }, '-=1')
      .to(svg1Path4, { duration: 1, strokeDashoffset: svg1Path4.getTotalLength() * 3 }, '-=1')
      .to(svg1Path2, { duration: 1, strokeDashoffset: svg1Path4.getTotalLength() * 2 }, '-=1')
      .add('stage-29')

      .to(point2, { duration: 0.1, fill: '#006525' })
      .to(point1, { duration: 0.2, autoAlpha: 0 }, '-=0.1')
      .to(point1, {
        duration: 0.1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 1.0,
          end: 0.859
        }
      })
      .to(point1Circle, { duration: 0.1, fill: '#ffffff' }, '-=0.1')
      .to(point1, { duration: 0.2, autoAlpha: 1 })
      .add('stage-30')

      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.859,
          end: 0.792
        }
      })
      .to(body, { duration: 1, ease: 'none', x: '-16.4%', y: '10.5%' }, '-=1')
      .to(country1, { duration: 0.1, left: '56.1%', top: '49.7%' }, '-=0.1')
      .add('stage-31')

      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.792,
          end: 0.638
        }
      })
      .to(body, { duration: 1, ease: 'none', x: '-27.7%', y: '8.7%' }, '-=1')
      .to(country2, { duration: 1, autoAlpha: 0 }, '-=1')
      .add('stage-32')

      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.638,
          end: 0.565
        }
      })
      .to(body, { duration: 1, ease: 'none', x: '-32.8%', y: '6.1%' }, '-=1')
      .to(country2, { duration: 1, autoAlpha: 1 }, '-=1')
      .add('stage-33')
      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.565,
          end: 0.505
        }
      })
      .to(body, { duration: 1, ease: 'none', x: '-36.5%', y: '7.6%' }, '-=1')
      .add('stage-34')

      .to(point1, {
        duration: 1,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.505,
          end: 0.38
        }
      })
      .to(body, { duration: 1, ease: 'none', x: '-44.8%', y: '2.2%' }, '-=1')
      .add('stage-35')

      .to(point1, {
        duration: 2,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.38,
          end: 0.275
        }
      })
      .to(body, { duration: 1, ease: 'none', x: '-50.9%', y: '-2.9%' }, '-=2')
      .to(chart1, { duration: 0.1, autoAlpha: 1 })
      .to(chart1Circle, { duration: 1, ease: 'power2.inOut', strokeDashoffset: chart1Circle.getTotalLength() - chart1Circle.getTotalLength() * 0.89 })
      .to(chart1CircleBack, { duration: 0.2, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.1')
      .to(chart1Text, { duration: 1, autoAlpha: 1 }, '-=0.5')
      .to(point1, { duration: 1, autoAlpha: 0 }, '-=1')
      .add('stage-36')

      .to(label0, { duration: 0.1, autoAlpha: 0 })
      .to(point1, {
        duration: 2,
        motionPath: {
          path: svg1Path1,
          align: svg1Path1,
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
          start: 0.275,
          end: 0.275
        }
      }, '-=0.1')
      .to(chart1Circle, { duration: 1, ease: 'power2.inOut', strokeDashoffset: 0 }, '-=2')
      .to(chart1Text, { duration: 1, autoAlpha: 0 }, '-=2')
      .to(chart2, { duration: 0.1, autoAlpha: 1 }, '-=1.1')
      .to(chart1Circle, { duration: 0.1, autoAlpha: 0 }, '-=1')
      .to(chart2Circle, { duration: 1, ease: 'power2.inOut', r: '50%', strokeWidth: 0 }, '-=1')
      .to(chart2Img1, { duration: 0.5, ease: 'power2.inOut', autoAlpha: 1 })
      .to(chart2Text1, { duration: 0.5, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.2')
      .to(chart2Img2, { duration: 0.5, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.4')
      .to(chart2Text2, { duration: 0.5, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.2')
      .to(chart2Img3, { duration: 0.5, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.4')
      .to(chart2Text3, { duration: 0.5, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.2')
      .add('stage-37')
      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 1 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1.5, x: '-50%', y: '-50%' }, '-=1')
      .add('stage-38')
      ;

    setTimeline(tl);
  }, []);


  useEffect(() => {
    if (!init) {
      if (timeline !== null) {
        setInit(true);
        timeline.seek(`stage-${stage}`);
        setLocalStage(stage);
      }
    }
  }, [init, stage, timeline]);
  useEffect(() => {
    let diff = Math.abs(localStage - stage);
    if (timeline !== null) {
      if (diff !== 0 && !transition) {
        setTransition(true);
        updateTransition(true);
        if (diff > 1) {
          refWrap.current.classList.add(styles.hide);
          setTimeout(() => {
            timeline.seek(`stage-${stage}`);
            refWrap.current.classList.remove(styles.hide);
            setTransition(false);
            setTimeout(() => {
              updateTransition(false);
            }, 800);
          }, 300);
        } else {
          let minimalDelay = false;
          let minimalDelayTimer = setTimeout(() => {
            minimalDelay = true;
          }, 500);
          // if(localStage - stage > 0){
          //   updateReverse(true);
          // }
          timeline.tweenTo(`stage-${stage}`, {
            onComplete: function () {
              setTransition(false);
              clearTimeout(minimalDelayTimer);
              if (minimalDelay) {
                updateTransition(false);
              } else {
                setTimeout(() => {
                  updateTransition(false);
                }, 800);
              }
            }
          });
        }
        setLocalStage(stage);

      }
    }
  }, [localStage, stage, timeline, transition, updateTransition]);
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.charts}>
          <div className={styles.chart} ref={refChart1}>
            <span ref={refChart1Text}>89,3%</span>
            <svg width="850" height="850" viewBox="0 0 850 850" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle ref={refChart1CircleBack} r="300" cx="425" cy="425" fill='#fcfcfc'/>
              <circle ref={refChart1Circle} r="25%" cx="50%" cy="50%" stroke="#67D672" strokeWidth={425} />
            </svg>
          </div>
          <div className={styles.chart} ref={refChart2}>
            <div className={styles.chart__logo}>
              <img src={`${path}/img/chart-logo-1.svg`} alt="" ref={refChart2Img1} />
              <span ref={refChart2Text1}>33,3%</span>
            </div>
            <div className={styles.chart__logo}>
              <img src={`${path}/img/chart-logo-2.svg`} alt="" ref={refChart2Img2} />
              <span ref={refChart2Text2}>33,3%</span>
            </div>
            <div className={styles.chart__logo}>
              <img src={`${path}/img/chart-logo-3.svg`} alt="" ref={refChart2Img3} />
              <span ref={refChart2Text3}>33,3%</span>
            </div>
            <svg width="856" height="854" viewBox="0 0 856 854" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle r="425" cx="50%" cy="50%" fill="#ffffff" />
              <path d="M56.9392 637.499C19.6415 572.897 0.00392425 499.617 5.88087e-07 425.021C-0.00392307 350.426 19.6259 277.143 56.9169 212.538C94.2078 147.932 147.846 94.2797 212.442 56.9717C277.038 19.6638 350.315 0.0147046 424.911 -0.000967183L425 424.999L56.9392 637.499Z" fill="#67D672" />
              <path d="M796.095 641.44C758.807 706.048 705.172 759.703 640.578 797.015C575.985 834.326 502.708 853.979 428.113 853.999C353.517 854.019 280.23 834.405 215.617 797.127C151.003 759.85 97.3395 706.223 60.0179 641.635L428 428.999L796.095 641.44Z" fill="#67D672" />
              <path d="M431 -0.000976562C505.528 -0.00097982 578.745 19.597 643.307 56.827C707.869 94.057 761.507 147.61 798.838 212.114C836.169 276.617 855.882 349.804 855.999 424.331C856.116 498.859 836.634 572.107 799.505 636.728L431 424.999L431 -0.000976562Z" fill="#67D672" />
              <circle ref={refChart2Circle} r="25%" cx="50%" cy="50%" stroke="#67D672" strokeWidth={425} />
              
            </svg>
          </div>
        </div>


        <div className={styles.overlay} ref={refOverlay}></div>
        <div className={styles.container} ref={refContainer}>
          <div className={styles.body} ref={refBody}>
            <div className={styles.countries}>
              <div className={`${styles.country}`} ref={el => refCountries.current[0] = el} >CHINA</div>
              <div className={`${styles.country}`} ref={el => refCountries.current[1] = el} >KAZAKHSTAN</div>
              <div className={`${styles.country}`} ref={el => refCountries.current[2] = el} >Russia</div>
              <div className={`${styles.country}`} ref={el => refCountries.current[3] = el} >BELARUS</div>
              <div className={`${styles.country}`} ref={el => refCountries.current[4] = el} >GERMANY</div>
              <div className={`${styles.country}`} ref={el => refCountries.current[5] = el} >Poland</div>
            </div>
            <div className={styles.labels}>
              <div className={`${styles.label} ${styles.label_0}`} ref={el => refLabels.current[0] = el} >CHONGQING, CHINA</div>
              <div className={`${styles.label} ${styles.label_1}`} ref={el => refLabels.current[1] = el} >DUISBURG, GERMANY</div>
              <div className={`${styles.label} ${styles.label_2}`} ref={el => refLabels.current[2] = el} >DOSTYK, KAZAKHSTAN</div>
              <div className={`${styles.label} ${styles.label_3}`} ref={el => refLabels.current[3] = el} >ALTYNKOL, KAZAKHSTAN</div>
              <div className={`${styles.label} ${styles.label_4}`} ref={el => refLabels.current[4] = el} >Post B, Russia</div>
              <div className={`${styles.label} ${styles.label_5}`} ref={el => refLabels.current[5] = el} >OSINOVKA, BELARUS</div>
              <div className={`${styles.label} ${styles.label_6}`} ref={el => refLabels.current[6] = el} >BREST, BELARUS</div>
              {/* <div className={`${styles.label} ${styles.label_7}`} ref={el => refLabels.current[7] = el} >Дуйсбург, Германия</div> */}
            </div>
            <div className={styles.svgs}>
              <div className={`${styles.svg} ${styles.svg_1}`} ref={refSvg1}>
                <svg width="2560" height="1440" viewBox="0 0 2560 1440" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/*russianMainPathMask */}
                  <mask id="maskMain1">
                    <path ref={refSvg1Inner3Mask} d="M2142 1132L2116.7 1113.75L2106.52 1097.96L2045.38 1063.56L2032.38 1046.01L2019.03 1040.4L1999.71 1027.06L1984.25 1000.03L1969.85 996.875L1960.36 975.816L1935.42 961.777L1921.01 956.863L1880.61 905.621L1835.64 887.019L1831.07 872.98L1798.39 838.585L1773.8 828.758L1760.8 804.189L1717.94 782.78L1712.32 773.304L1683.16 750.49L1669.45 741.716L1642.05 743.822L1630.11 742.067L1625.19 745.577L1615.35 746.63L1605.16 743.822L1580.57 742.067L1561.59 734.345L1548.6 700.301L1554.22 686.613L1553.51 672.574L1558.78 662.747L1555.27 651.515L1549.65 649.76L1531.03 631.159L1489.57 612.908L1472.71 613.61L1457.95 609.749L1447.76 610.451L1411.22 594.306L1402.09 596.061L1389.09 592.552L1343.06 577.46L1338.5 595.008L1324.8 616.769L1308.28 629.404L1295.63 622.033L1290.36 623.437L1274.91 620.279L1269.28 613.259L1258.39 608.696H1252.07L1247.5 613.259L1243.29 610.451H1231.69L1222.56 604.836L1214.48 595.359L1200.42 588.34L1192.34 578.162L1166.69 571.493L1155.1 579.916L1147.37 579.214L1139.29 573.599H1129.8L1123.83 564.474L1105.56 559.56L1097.83 554.295L1080.62 551.838L1073.24 548.329L1064.1 549.382L1059.19 547.276L1050.75 550.084L1036.35 547.276L1021.59 540.256L996.297 542.713L980.136 529.025L964.677 534.29L955.894 523.76L952.38 516.039L938.327 511.827L931.652 503.053L928.138 502L920.409 505.861L900.031 504.457L891.248 514.635L862.439 518.496L855.763 526.568L832.575 530.078L828.359 530.78L825.9 533.237L807.279 540.958L791.469 543.766L785.145 549.382L774.605 553.593L728.931 592.201L722.959 593.604L712.067 602.73L684.663 612.206L663.583 609.749L638.638 613.259L589.451 611.153L560.291 623.086L501.618 614.312L438.377 626.245L418 623.086" stroke="white" strokeWidth="6" strokeMiterlimit="10" />
                  </mask>
                  {/*MainPathMask */}
                  <mask id="maskMain2">
                    <path ref={refSvg1Inner1Mask} d="M2142 1132L2116.7 1113.75L2106.52 1097.96L2045.38 1063.56L2032.38 1046.01L2019.03 1040.4L1999.71 1027.06L1984.25 1000.03L1969.85 996.875L1960.36 975.816L1935.42 961.777L1921.01 956.863L1880.61 905.621L1835.64 887.019L1831.07 872.98L1798.39 838.585L1773.8 828.758L1760.8 804.189L1717.94 782.78L1712.32 773.304L1683.16 750.49L1669.45 741.716L1642.05 743.822L1630.11 742.067L1625.19 745.577L1615.35 746.63L1605.16 743.822L1580.57 742.067L1561.59 734.345L1548.6 700.301L1554.22 686.613L1553.51 672.574L1558.78 662.747L1555.27 651.515L1549.65 649.76L1531.03 631.159L1489.57 612.908L1472.71 613.61L1457.95 609.749L1447.76 610.451L1411.22 594.306L1402.09 596.061L1389.09 592.552L1343.06 577.46L1338.5 595.008L1324.8 616.769L1308.28 629.404L1295.63 622.033L1290.36 623.437L1274.91 620.279L1269.28 613.259L1258.39 608.696H1252.07L1247.5 613.259L1243.29 610.451H1231.69L1222.56 604.836L1214.48 595.359L1200.42 588.34L1192.34 578.162L1166.69 571.493L1155.1 579.916L1147.37 579.214L1139.29 573.599H1129.8L1123.83 564.474L1105.56 559.56L1097.83 554.295L1080.62 551.838L1073.24 548.329L1064.1 549.382L1059.19 547.276L1050.75 550.084L1036.35 547.276L1021.59 540.256L996.297 542.713L980.136 529.025L964.677 534.29L955.894 523.76L952.38 516.039L938.327 511.827L931.652 503.053L928.138 502L920.409 505.861L900.031 504.457L891.248 514.635L862.439 518.496L855.763 526.568L832.575 530.078L828.359 530.78L825.9 533.237L807.279 540.958L791.469 543.766L785.145 549.382L774.605 553.593L728.931 592.201L722.959 593.604L712.067 602.73L684.663 612.206L663.583 609.749L638.638 613.259L589.451 611.153L560.291 623.086L501.618 614.312L438.377 626.245L418 623.086" stroke="white" strokeWidth="8" strokeMiterlimit="10" />
                  </mask>
                  {/*russianMainPath */}
                  <path ref={refSvg1Inner3} d="M2142 1132L2116.7 1113.75L2106.52 1097.96L2045.38 1063.56L2032.38 1046.01L2019.03 1040.4L1999.71 1027.06L1984.25 1000.03L1969.85 996.875L1960.36 975.816L1935.42 961.777L1921.01 956.863L1880.61 905.621L1835.64 887.019L1831.07 872.98L1798.39 838.585L1773.8 828.758L1760.8 804.189L1717.94 782.78L1712.32 773.304L1683.16 750.49L1669.45 741.716L1642.05 743.822L1630.11 742.067L1625.19 745.577L1615.35 746.63L1605.16 743.822L1580.57 742.067L1561.59 734.345L1548.6 700.301L1554.22 686.613L1553.51 672.574L1558.78 662.747L1555.27 651.515L1549.65 649.76L1531.03 631.159L1489.57 612.908L1472.71 613.61L1457.95 609.749L1447.76 610.451L1411.22 594.306L1402.09 596.061L1389.09 592.552L1343.06 577.46L1338.5 595.008L1324.8 616.769L1308.28 629.404L1295.63 622.033L1290.36 623.437L1274.91 620.279L1269.28 613.259L1258.39 608.696H1252.07L1247.5 613.259L1243.29 610.451H1231.69L1222.56 604.836L1214.48 595.359L1200.42 588.34L1192.34 578.162L1166.69 571.493L1155.1 579.916L1147.37 579.214L1139.29 573.599H1129.8L1123.83 564.474L1105.56 559.56L1097.83 554.295L1080.62 551.838L1073.24 548.329L1064.1 549.382L1059.19 547.276L1050.75 550.084L1036.35 547.276L1021.59 540.256L996.297 542.713L980.136 529.025L964.677 534.29L955.894 523.76L952.38 516.039L938.327 511.827L931.652 503.053L928.138 502L920.409 505.861L900.031 504.457L891.248 514.635L862.439 518.496L855.763 526.568L832.575 530.078L828.359 530.78L825.9 533.237L807.279 540.958L791.469 543.766L785.145 549.382L774.605 553.593L728.931 592.201L722.959 593.604L712.067 602.73L684.663 612.206L663.583 609.749L638.638 613.259L589.451 611.153L560.291 623.086L501.618 614.312L438.377 626.245L418 623.086" stroke="#006525" strokeWidth="6" strokeMiterlimit="10" mask="url(#maskMain1)" strokeLinejoin="round" />

                  {/* germanyMainPath */}
                  <path ref={refSvg1Inner4} d="M2142 1132L2116.7 1113.75L2106.52 1097.96L2045.38 1063.56L2032.38 1046.01L2019.03 1040.4L1999.71 1027.06L1984.25 1000.03L1969.85 996.875L1960.36 975.816L1935.42 961.777L1921.01 956.863L1880.61 905.621L1835.64 887.019L1831.07 872.98L1798.39 838.585L1773.8 828.758L1760.8 804.189L1717.94 782.78L1712.32 773.304L1683.16 750.49L1669.45 741.716L1642.05 743.822L1630.11 742.067L1625.19 745.577L1615.35 746.63L1605.16 743.822L1580.57 742.067L1561.59 734.345L1548.6 700.301L1554.22 686.613L1553.51 672.574L1558.78 662.747L1555.27 651.515L1549.65 649.76L1531.03 631.159L1489.57 612.908L1472.71 613.61L1457.95 609.749L1447.76 610.451L1411.22 594.306L1402.09 596.061L1389.09 592.552L1343.06 577.46L1338.5 595.008L1324.8 616.769L1308.28 629.404L1295.63 622.033L1290.36 623.437L1274.91 620.279L1269.28 613.259L1258.39 608.696H1252.07L1247.5 613.259L1243.29 610.451H1231.69L1222.56 604.836L1214.48 595.359L1200.42 588.34L1192.34 578.162L1166.69 571.493L1155.1 579.916L1147.37 579.214L1139.29 573.599H1129.8L1123.83 564.474L1105.56 559.56L1097.83 554.295L1080.62 551.838L1073.24 548.329L1064.1 549.382L1059.19 547.276L1050.75 550.084L1036.35 547.276L1021.59 540.256L996.297 542.713L980.136 529.025L964.677 534.29L955.894 523.76L952.38 516.039L938.327 511.827L931.652 503.053L928.138 502L920.409 505.861L900.031 504.457L891.248 514.635L862.439 518.496L855.763 526.568L832.575 530.078L828.359 530.78L825.9 533.237L807.279 540.958L791.469 543.766L785.145 549.382L774.605 553.593L728.931 592.201L722.959 593.604L712.067 602.73L684.663 612.206L663.583 609.749L638.638 613.259L589.451 611.153L560.291 623.086L501.618 614.312L438.377 626.245L418 623.086" stroke="#67D672" strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round" />

                  {/* secondMainPath */}
                  <path ref={refSvg1Inner2} d="M2142 1132L2116.7 1113.75L2106.52 1097.96L2045.38 1063.56L2032.38 1046.01L2019.03 1040.4L1999.71 1027.06L1984.25 1000.03L1969.85 996.875L1960.36 975.816L1935.42 961.777L1921.01 956.863L1880.61 905.621L1835.64 887.019L1831.07 872.98L1798.39 838.585L1773.8 828.758L1760.8 804.189L1717.94 782.78L1712.32 773.304L1683.16 750.49L1669.45 741.716L1642.05 743.822L1630.11 742.067L1625.19 745.577L1615.35 746.63L1605.16 743.822L1580.57 742.067L1561.59 734.345L1548.6 700.301L1554.22 686.613L1553.51 672.574L1558.78 662.747L1555.27 651.515L1549.65 649.76L1531.03 631.159L1489.57 612.908L1472.71 613.61L1457.95 609.749L1447.76 610.451L1411.22 594.306L1402.09 596.061L1389.09 592.552L1343.06 577.46L1338.5 595.008L1324.8 616.769L1308.28 629.404L1295.63 622.033L1290.36 623.437L1274.91 620.279L1269.28 613.259L1258.39 608.696H1252.07L1247.5 613.259L1243.29 610.451H1231.69L1222.56 604.836L1214.48 595.359L1200.42 588.34L1192.34 578.162L1166.69 571.493L1155.1 579.916L1147.37 579.214L1139.29 573.599H1129.8L1123.83 564.474L1105.56 559.56L1097.83 554.295L1080.62 551.838L1073.24 548.329L1064.1 549.382L1059.19 547.276L1050.75 550.084L1036.35 547.276L1021.59 540.256L996.297 542.713L980.136 529.025L964.677 534.29L955.894 523.76L952.38 516.039L938.327 511.827L931.652 503.053L928.138 502L920.409 505.861L900.031 504.457L891.248 514.635L862.439 518.496L855.763 526.568L832.575 530.078L828.359 530.78L825.9 533.237L807.279 540.958L791.469 543.766L785.145 549.382L774.605 553.593L728.931 592.201L722.959 593.604L712.067 602.73L684.663 612.206L663.583 609.749L638.638 613.259L589.451 611.153L560.291 623.086L501.618 614.312L438.377 626.245L418 623.086" stroke="#006525" strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round" />
                  {/* mainPath */}
                  <path ref={refSvg1Inner1} d="M2142 1132L2116.7 1113.75L2106.52 1097.96L2045.38 1063.56L2032.38 1046.01L2019.03 1040.4L1999.71 1027.06L1984.25 1000.03L1969.85 996.875L1960.36 975.816L1935.42 961.777L1921.01 956.863L1880.61 905.621L1835.64 887.019L1831.07 872.98L1798.39 838.585L1773.8 828.758L1760.8 804.189L1717.94 782.78L1712.32 773.304L1683.16 750.49L1669.45 741.716L1642.05 743.822L1630.11 742.067L1625.19 745.577L1615.35 746.63L1605.16 743.822L1580.57 742.067L1561.59 734.345L1548.6 700.301L1554.22 686.613L1553.51 672.574L1558.78 662.747L1555.27 651.515L1549.65 649.76L1531.03 631.159L1489.57 612.908L1472.71 613.61L1457.95 609.749L1447.76 610.451L1411.22 594.306L1402.09 596.061L1389.09 592.552L1343.06 577.46L1338.5 595.008L1324.8 616.769L1308.28 629.404L1295.63 622.033L1290.36 623.437L1274.91 620.279L1269.28 613.259L1258.39 608.696H1252.07L1247.5 613.259L1243.29 610.451H1231.69L1222.56 604.836L1214.48 595.359L1200.42 588.34L1192.34 578.162L1166.69 571.493L1155.1 579.916L1147.37 579.214L1139.29 573.599H1129.8L1123.83 564.474L1105.56 559.56L1097.83 554.295L1080.62 551.838L1073.24 548.329L1064.1 549.382L1059.19 547.276L1050.75 550.084L1036.35 547.276L1021.59 540.256L996.297 542.713L980.136 529.025L964.677 534.29L955.894 523.76L952.38 516.039L938.327 511.827L931.652 503.053L928.138 502L920.409 505.861L900.031 504.457L891.248 514.635L862.439 518.496L855.763 526.568L832.575 530.078L828.359 530.78L825.9 533.237L807.279 540.958L791.469 543.766L785.145 549.382L774.605 553.593L728.931 592.201L722.959 593.604L712.067 602.73L684.663 612.206L663.583 609.749L638.638 613.259L589.451 611.153L560.291 623.086L501.618 614.312L438.377 626.245L418 623.086" stroke="#67D672" strokeWidth="6" strokeMiterlimit="10" mask="url(#maskMain2)" strokeLinejoin="round" />


                  <g className={styles.cityPoints}>
                    <circle className={`${styles.point} ${styles.point_0}`} ref={el => refCityPoints.current[0] = el} cx="418" cy="623" r="16" />
                    <circle className={`${styles.point} ${styles.point_1}`} ref={el => refCityPoints.current[1] = el} cx="2153" cy="1140" r="7" />
                    <circle className={`${styles.point} ${styles.point_2}`} ref={el => refCityPoints.current[2] = el} cx="1636" cy="850" r="4" />
                    <circle className={`${styles.point} ${styles.point_3}`} ref={el => refCityPoints.current[3] = el} cx="1710" cy="772" r="4" />
                    <circle className={`${styles.point} ${styles.point_4}`} ref={el => refCityPoints.current[4] = el} cx="710" cy="603" r="4" />
                    <circle className={`${styles.point} ${styles.point_5}`} ref={el => refCityPoints.current[5] = el} cx="1341" cy="585" r="4" />
                  </g>
                  <g className={styles.mainPoints} ref={refPoint1}>
                    <circle className={styles.point} cx="0" cy="0" r="16" />
                    <circle className={styles.point} cx="0" cy="0" r="16" />
                    <circle className={styles.point} cx="0" cy="0" r="13" stroke='#67D672' strokeWidth={6} />
                  </g>
                </svg>
              </div>
              <div className={`${styles.svg} ${styles.svg_2}`} ref={refSvg2}>
                <svg width="1858" height="1326" viewBox="0 0 1858 1326" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask1">
                    <path ref={refSvg2Inner1Mask} d="M2 2L12 125.5L51 162L62.5 231.5L117 291.5L160.5 319L186 370L263.5 413.5C267.166 448.611 286.907 484.559 286.907 484.559L375.29 562.258L403.217 630.748L442.54 687.288L526.751 739.35L602.166 794.331L690.153 839.061L808.238 929.557L856.874 985.629L896.941 1053.47L1134.73 1088.53C1134.73 1088.53 1184.26 1106.12 1211.17 1123.11C1232.69 1136.71 1248.69 1136.13 1254 1134.14C1271.65 1136.34 1299.19 1173.87 1319.28 1191.53C1339.37 1209.19 1392.98 1239.01 1408.5 1246L1654.83 1267.29L1772.83 1323.79L1855.83 1312.79" stroke="white" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
                  </mask  >
                  <mask id="mask2">
                    <path ref={refSvg2Inner2Mask} d="M2 2L12 125.5L51 162L62.5 231.5L117 291.5L160.5 319L186 370L263.5 413.5C267.166 448.611 286.907 484.559 286.907 484.559L375.29 562.258L403.217 630.748L442.54 687.288L526.751 739.35L602.166 794.331L690.153 839.061L808.238 929.557L856.874 985.629L896.941 1053.47L1134.73 1088.53C1134.73 1088.53 1184.26 1106.12 1211.17 1123.11C1232.69 1136.71 1248.69 1136.13 1254 1134.14C1271.65 1136.34 1299.19 1173.87 1319.28 1191.53C1339.37 1209.19 1392.98 1239.01 1408.5 1246L1654.83 1267.29L1772.83 1323.79L1855.83 1312.79" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                  </mask  >
                  <path ref={refSvg2Inner1} d="M2 2L12 125.5L51 162L62.5 231.5L117 291.5L160.5 319L186 370L263.5 413.5C267.166 448.611 286.907 484.559 286.907 484.559L375.29 562.258L403.217 630.748L442.54 687.288L526.751 739.35L602.166 794.331L690.153 839.061L808.238 929.557L856.874 985.629L896.941 1053.47L1134.73 1088.53C1134.73 1088.53 1184.26 1106.12 1211.17 1123.11C1232.69 1136.71 1248.69 1136.13 1254 1134.14C1271.65 1136.34 1299.19 1173.87 1319.28 1191.53C1339.37 1209.19 1392.98 1239.01 1408.5 1246L1654.83 1267.29L1772.83 1323.79L1855.83 1312.79" mask="url(#mask1)" stroke="#67D672" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="8 16" />
                  <path ref={refSvg2Inner2} d="M2 2L12 125.5L51 162L62.5 231.5L117 291.5L160.5 319L186 370L263.5 413.5C267.166 448.611 286.907 484.559 286.907 484.559L375.29 562.258L403.217 630.748L442.54 687.288L526.751 739.35L602.166 794.331L690.153 839.061L808.238 929.557L856.874 985.629L896.941 1053.47L1134.73 1088.53C1134.73 1088.53 1184.26 1106.12 1211.17 1123.11C1232.69 1136.71 1248.69 1136.13 1254 1134.14C1271.65 1136.34 1299.19 1173.87 1319.28 1191.53C1339.37 1209.19 1392.98 1239.01 1408.5 1246L1654.83 1267.29L1772.83 1323.79L1855.83 1312.79" mask="url(#mask2)" stroke="#006525" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="8 16" />
                </svg>


              </div>

            </div>
            <div className={styles.bg} ref={refBg}>
              {/* <img src={`${path}/img/map.webp`} alt="" /> */}
              <div className={styles.bg__overlay} ref={refBgOverlay}></div>
              <div className={styles.bg__tiles}>
                
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-1.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-2.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-3.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-4.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-5.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-6.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-7.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-8.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-9.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-10.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-11.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-12.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-13.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-14.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-15.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-16.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-17.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-18.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-19.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-20.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-21.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-22.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-23.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-24.webp`} alt="" />
                </div>
                <div className={styles.bg_tile}>
                  <img src={`${path}/img/map/tile-25.webp`} alt="" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );

}

export default Map;
